import NextImage from 'next/legacy/image'
import Link from 'next/link'
import React from 'react'
import { useAllProductIds } from '../../../hooks/useAllProductIds'
import { useTranslate } from '../../contexts/TranslationContext'
import SvgCross from '../../svg/icons/Cross'
import { Button } from '../shared/Button'
import { Tag } from '../shared/Tag'
import style from './ProductImage.module.sass'

type ProductImageProps = {
	title: string
	url: string
	imageUrl: string
	handleClick: (id: string) => void
	id: string
}

export const ProductImage = React.memo(function ProductImage(props: ProductImageProps) {
	const allProductsStats = useAllProductIds(props.id)

	const indexNumber =
		typeof allProductsStats.productIndex === 'number' && allProductsStats.productIndex >= 0
			? allProductsStats.productIndex + 1
			: undefined

	const translate = useTranslate()
	return (
		<div className={style.root}>
			<Link href={props.url} className={style.card} title={props.title}>
				{indexNumber && (
					<div className={style.tagWrapper}>
						<Tag
							color={indexNumber <= 3 ? 'greenLight' : allProductsStats.isFed ? 'pink' : 'greyMedium'}
							label={`${indexNumber}.`}
						/>
					</div>
				)}
				<div className={style.imageWrapper}>
					<div className={style.image}>
						<NextImage
							src={props.imageUrl}
							alt={translate('alternativeText.productImage')}
							layout="fill"
							objectFit="contain"
						/>
					</div>
				</div>
			</Link>
			<div className={style.buttonWrapper}>
				<Button
					iconButtonStyle={{
						color: 'whiteBordered',
						size: 'extraSmall',
					}}
					label={<SvgCross />}
					icon={{ aloneStanding: true, fillPrimary: true }}
					onClick={() => props.handleClick(props.id)}
					ariaLabel={translate('productImage.delete.button')}
				/>
			</div>
		</div>
	)
})
